import React from 'react';
import './Home.css';
import { useLanguage } from '../LanguageContext';

const Home = () => {
  const { t } = useLanguage();
  
  return (
    <section id="home" className="hero-banner" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/assets/ht_bg_banner.png)`}}>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>{t('welcomeTo')} <span style={{color: '#ff8c42'}}>{t('honouredTech')}</span></h1>
        <p className="hero-subtitle">{t('welcomeSubtitle')}</p>
        <p className="hero-description">
          {t('welcomeDescription')}
        </p>
      </div>
    </section>
  );
};

export default Home;
